import React from "react";

export default function card(props) {
  return (
      <div className="card my-2" style={{height:"25rem"}}>
        <div className="card-circle-container rounded-circle mx-auto my-3"><img src={props.src} width="40" height="40" className="card-img-top img-fluid card-img" alt="..." /></div>
        <div className="card-body">
            <h6 className="blue-text text-center mb-3">{props.title}</h6>
          <p className="card-text text-center">
            {props.text}
          </p>
        </div>
      </div>
  );
}
